<template>
  <div class="document-resultItem" :class="{ 'is-current' : item.isCurrent }">
    <div class="document-resultItem-title" v-if="state.tab === 1 && isFilteredTheme === false && type !== 'connection'">
      <p class="title list02" v-html="item.title"></p>
      <!-- <i class="icon" @click="clickFilterTheme.emitEvent(item)">
        <span class="tip">このテーマで絞り込み</span>
        <IcnTheme />
      </i> -->
    </div>
    <div class="document-resultItem-head" :class="{ 'col3': state.tab === 1}">
      <p class="document-resultItem-caption">{{item.typeMainText}}</p>
      <div class="document-resultItem-info">
        <template v-if="item.typeText === '判例'">
          <p class="document-resultItem-detail" v-if="item.date">
            <strong>裁判年月日</strong><strong>:</strong><span>{{ item.date }}</span>
          </p>
          <p class="document-resultItem-detail" v-if="item.saibansyoText">
            <strong>裁判所</strong><strong>:</strong><span>{{item.saibansyoText}}</span>
          </p>
          <p class="document-resultItem-detail" v-if="item.case_name">
            <strong>事件番号</strong><strong>:</strong><span>{{ sliceText(item.case_name) }}</span>
          </p>
          <p class="document-resultItem-detail" v-if="item.source">
            <strong>出典</strong><strong>:</strong><span>{{ sliceText(item.source) }}</span>
          </p>
        </template>
        <template v-else>
          <p class="document-resultItem-detail" v-if="item.date">
            <strong>年月日</strong><strong>:</strong><span>{{ item.date }}</span>
          </p>
          <p class="document-resultItem-detail">
            <strong>発翰番号</strong><strong>:</strong><span>{{item.hakkanText}}<template v-if="item.hakkan1">{{ item.hakkan1 }}</template></span>
          </p>
        </template>
      </div>
      <template v-if="state.tab === 1 && isFilteredTheme === false && !isFromAdminSystem()">
        <ButtonViewLater
          :afterId="item.after_id"
          :paramId="item.id"
          :paramKey="'pj'"
          :gaClass="'ga-precedent-list-view-later'"
          @onViewLaterChanged="clickViewLater.emitEvent"
        />
      </template>
    </div>
    <div class="document-resultItem-body list02" v-if="item.shortenedText">
      <template v-if="item.sub_title"><p>{{ item.sub_title }}</p></template>
      <p class="document-resultItem-text" v-html="item.shortenedText"></p>
    </div>
    <div class="document-resultItem-aside">
      <p class="document-resultItem-item" @click="detailClick.emitEvent(item.id)">
        <span class="icon">
          <IcnPaper />
        </span>
        詳細 ≫
      </p>
      <template v-if="type !== 'connection'">
        <p class="document-resultItem-item" v-if="item.related.length" :class="{ 'is-selected': item.connection === 'related' }" @click="changeView.openRelated">
          <span class="icon">
            <IcnList />
          </span>
          関連要旨
        </p>
        <p class="document-resultItem-item" v-if="item.reference.length" :class="{ 'is-selected': item.connection === 'reference' }" @click="changeView.openReference">
          <span class="icon">
            <IcnList />
          </span>
          参照
        </p>
      </template>
    </div>
    <div class="document-resultItem-view">
      <template v-if="item.connection === 'related'">
        <FontawesomeIcon v-if="item.relatedItems === undefined" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
        <template v-else>
          <PCDocumentPartResultItem
            v-for="(relatedItem) in item.relatedItems"
            :key="item.id + '_relatedItem_' + relatedItem.id"
            :item="relatedItem"
            type="connection"
            @detailClick="detailClick.emitEvent"
          />
        </template>
      </template>
      <template v-if="item.connection === 'reference'">
        <FontawesomeIcon v-if="item.referenceItems === undefined" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
        <template v-else>
          <PCDocumentPartResultItem
            v-for="(referenceItem) in item.referenceItems"
            :key="item.id + '_referenceItem_' + referenceItem.id"
            :item="referenceItem"
            type="connection"
            @detailClick="detailClick.emitEvent"
          />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, computed } from '@vue/composition-api'
import store from '@/store'
import { isFromAdminSystem } from '@/util/common'

export default defineComponent({
  name: 'PCDocumentPartResultItem',
  props: {
    item: {
      type: Object,
      default: undefined
    },
    type: {
      type: String,
      default: undefined
    },
    isFilteredTheme: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const clickFilterTheme = reactive({
      emitEvent: (payload) => {
        context.emit('clickFilterTheme', payload)
      }
    })

    const clickViewLater = reactive({
      emitEvent: (payload) => {
        context.emit('clickViewLater', payload)
      }
    })

    const detailClick = reactive({
      emitEvent: (detailId) => {
        context.emit('detailClick', detailId)
      }
    })

    const changeView = reactive({
      openRelated: () => {
        context.emit('openRelated')
      },
      openReference: () => {
        context.emit('openReference')
      }
    })

    const state = reactive({
      tab: computed(() => {
        return store.state.precedent.tab
      })
    })

    const sliceText = (text) => {
      const maxLength = 15

      let result = text
      if (text.length > maxLength) {
        result = text.slice(0, maxLength) + '…'
      }

      return result
    }

    return {
      props,
      clickFilterTheme,
      clickViewLater,
      detailClick,
      changeView,
      state,
      isFromAdminSystem,
      sliceText
    }
  }
})
</script>

<style lang="scss" scoped>
  .document-resultItem {
    margin-top: 12px;
    padding: 12px 18px 0;
    background-color: #fff;
    &.is-current {
      background-color: #D4E7F4;
    }
    & + & {
      margin-top: 0;
      padding-top: 20px;
      border-top: 1px solid #DDDDDD;
    }
    .document-resultItem {
      width: calc(100% + 18px);
      //margin-left: -8px;
      //margin-left: 10px;
      &:nth-of-type(1) {
        margin-top: 0;
      }
      &.is-current {
        background-color: #D4E7F4;
      }
    }
    &-head {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      &.col3 > .document-resultItem-info {
        width: calc(100% - 84px - 32px - 54px);
        margin-right: 20px;
        flex-basis: 100%;
      }
    }
    &-info {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      width: calc(100% - 84px - 32px);
      margin-left: 32px;
      margin-bottom: -8px;
    }
    &-caption {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 84px;
      border: 1px solid #E4E4E4;
      text-align: center;
      font-size: 12px;
      color: #333;
      background-color: #fff;
    }
    &-detail {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      width: 50%;
      padding-right: 20px;
      font-size: 12px;
      margin-bottom: 8px;
      strong {
        width: 62px;
        font-weight: bold;
        & + strong {
          width: 1em;
        }
      }
      span {
        width: calc(100% - 57px - 1em);
      }
    }
    &-title {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .title {
        font-size: 18px;
        font-weight: bold;
        line-height: 1.22;
      }
      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        color: $color-link;
        position: relative;
        cursor: pointer;
        .tip {
          position: absolute;
          top: -20px;
          //margin-left: 4px;
          right: 0;
          transform: translate3d(0,0,0);
          font-size: 1.4rem;
          font-weight: normal;
          white-space: nowrap;
          opacity: 0;
          transition: opacity .2s;
        }
        &:hover {
          -webkit-box-shadow: 0 5px 20px rgb(0 0 0 / 16%);
          box-shadow: 0 5px 20px rgb(0 0 0 / 16%);
          .tip {
            opacity: 1;
          }
        }
        svg {
          width: 16px;
          height: 16px;
        }
      }
      & + .document-resultItem-head {
        margin-top: 20px;
      }
    }
    &-body {
      margin-top: 32px;
      font-size: 14px;
      color: #555555;
      line-height: 1.214;
    }
    &-aside {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      margin-top: 12px;
    }
    &-item {
      display: flex;
      align-items: center;
      padding: 9px 14px 17px;
      color: #005BAC;
      font-size: 12px;
      cursor: pointer;
      &.is-selected {
        background-color: #fff;
      }
      .icon {
        margin-right: 8px;
      }
      &:nth-of-type(1) {
        margin-right: auto;
      }
    }
  }

  .sp {
    .document-resultItem {
      &-info {
        display: block;
        width: calc(100% - 84px - 16px - 34px);
        margin: 0 8px;
      }
      &-detail {
        width: 100%;
        padding-right: 0;
        &.place,
        &.reference {
          display: none;
        }
      }
      &-body {
        margin-top: 20px;
      }
    }
  }
</style>
